import {
  LOG_OUT,
  GET_VENDOR_ALL_TAKEAWAY_ORDER,
  GET_VENDOR_ALL_CURBSIDE_ORDER,
  GET_VENDOR_ALL_SKIPTHELINE_ORDER,
  GET_VENDOR_ALL_DINEIN_ORDER,
  GET_VENDOR_ALL_BUFFET_ORDER,
  GET_VENDOR_ALL_CATERING_ORDER,
  GET_VENDOR_ALL_DRIVETHRU_ORDER,
  GET_VENDOR_ALL_DELIVERY_ORDER,
  CREATE_ORDER_VENDOR,
  FILTERED_MENU_ORDER,
  UPDATE_CART_FILTERED_MENU_ORDER,
  SET_VENDOR_ORDERING_CART_DATA,
  UPDATE_VENDOR_ORDERING_CART_DATA,
  SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
  UPDATE_ORDER_DATA_SOCKET,
  SELECTED_SUBSTITUTE_ITEM,
  SET_ORDER_TIP,
  SET_ORDER_DONATION,
  CLEAR_CART_DATA,
  CLEAR_CART_DATA_USER_DATA,
  UPDATE_PAYMENT_METHOD,
  UPDATE_PAYMENT_WALLET_DETAILS,
  ORDER_ID,
  SUBSTITUTE_EXISTING_RECORDS,
  GET_ALL_DEBIT_CREDIT_MEMO,
  VIEW_MEMO_DETAILS,
  UPDATE_SELECTED_CATEGORY_TAB,
  APPLY_OFFER_VENDOR,
  SUGGESTIONS_DATA,
  SET_VENDOR_ORDERING_EDIT_DATA,
  ADD_NEW_SELECTED_ITEM,
  ADD_NEW_EXISTING_RECORDS,
  CLEAR_ORDER_TYPE_DETAILS,
  SET_ORDER_TYPE_DETAILS,
  SET_CALLING_INFO,
  SET_TWILIO_TOKEN,
} from "../../types";

const initialState = {
  vendor_get_all_takeaway_order: "",
  vendor_get_all_curbside_order: [],
  vendor_get_all_skiptheline_order: [],
  vendor_get_all_dinein_order: [],
  vendor_get_all_buffet_order: [],
  vendor_get_all_catering_order: [],
  vendor_get_all_drivethru_order: [],
  vendor_get_all_delivery_order: [],
  order_id: "",
  substitute_existing_record: {},
  substitute_item_data: [],
  vendor_cart_data: [],
  vendor_order_data: {},
  vendor_filtered_menu: [],
  all_debit_creit_memo: [],
  memo_details: {},
  vendor_suggestions_menu: [],
  get_edit_order_data: {},
  add_new_selected_item_data: [],
  add_new_selected_existing_record: {},
  orderTypeDetails: {},
  callingInfo: null,
  TwilioCallingToken: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_VENDOR_ALL_TAKEAWAY_ORDER:
      let updatedOrderDataa = action.payload.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      // let latestData = action.payload.sort(function (a, b) {
      //   return a.getTime() - b.getTime();
      // });
      return {
        ...state,
        vendor_get_all_takeaway_order: updatedOrderDataa,
      };

    case UPDATE_ORDER_DATA_SOCKET:
      let existingOrderData = [...state.vendor_get_all_takeaway_order];
      let updatedOrderData = [];
      let checkIfFound = false;

      for (let i = 0; i < state.vendor_get_all_takeaway_order.length; i++) {
        if (existingOrderData[i]._id === action.payload._id) {
          updatedOrderData.push(action.payload);
          checkIfFound = true;
        } else {
          updatedOrderData.push(existingOrderData[i]);
        }
      }

      if (!checkIfFound) {
        updatedOrderData.push(action.payload);
      }
      updatedOrderData = updatedOrderData.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      return {
        ...state,
        vendor_get_all_takeaway_order: updatedOrderData,
      };
    case GET_VENDOR_ALL_CURBSIDE_ORDER:
      return {
        ...state,
        vendor_get_all_curbside_order: action.payload,
      };
    case GET_VENDOR_ALL_SKIPTHELINE_ORDER:
      return {
        ...state,
        vendor_get_all_skiptheline_order: action.payload,
      };
    case GET_VENDOR_ALL_DINEIN_ORDER:
      return {
        ...state,
        vendor_get_all_dinein_order: action.payload,
      };
    case GET_VENDOR_ALL_BUFFET_ORDER:
      return {
        ...state,
        vendor_get_all_buffet_order: action.payload,
      };
    case GET_VENDOR_ALL_CATERING_ORDER:
      return {
        ...state,
        vendor_get_all_catering_order: action.payload,
      };
    case GET_VENDOR_ALL_DRIVETHRU_ORDER:
      return {
        ...state,
        vendor_get_all_drivethru_order: action.payload,
      };
    case GET_VENDOR_ALL_DELIVERY_ORDER:
      return {
        ...state,
        vendor_get_all_delivery_order: action.payload,
      };
    case CREATE_ORDER_VENDOR:
      return {
        ...state,
        vendor_order_data: action.payload,
      };

    case UPDATE_SELECTED_CATEGORY_TAB:
      let actualData = JSON.parse(JSON.stringify(state.vendor_order_data));
      actualData.selectedTabId = action.payload;
      return {
        ...state,
        vendor_order_data: actualData,
      };

    case UPDATE_PAYMENT_METHOD:
      let update_order_data = { ...state.vendor_order_data };
      update_order_data.payment_method = action.payload;
      return {
        ...state,
        vendor_order_data: update_order_data,
      };
    case UPDATE_PAYMENT_WALLET_DETAILS:
      let update_order_data_wallet = { ...state.vendor_order_data };
      update_order_data_wallet.walletDetails = action.payload;
      return {
        ...state,
        vendor_order_data: update_order_data_wallet,
      };
    case FILTERED_MENU_ORDER:
      return {
        ...state,
        vendor_filtered_menu: action.payload,
      };
    case UPDATE_CART_FILTERED_MENU_ORDER:
      //existingData;

      let existingData = JSON.parse(
        JSON.stringify(state?.vendor_filtered_menu)
      );
      //let updatedData = [];
      for (let i = 0; i < existingData.length; i++) {
        for (let j = 0; j < existingData?.[i]?.items.length; j++) {
          if (existingData?.[i]?.items?.[j]?._id === action.payload?.id) {
            existingData[i].items[j].cartLength = action.payload?.cartLength;
          }
        }
      }
      // let existingData1 = [...existingData];
      return {
        ...state,
        vendor_filtered_menu: existingData,
      };
    case SET_VENDOR_ORDERING_CART_DATA:
      let existingCartData = JSON.parse(JSON.stringify(state.vendor_cart_data));

      existingCartData.push(action.payload?.order_items);
      return {
        ...state,
        vendor_cart_data: existingCartData,
      };

    case UPDATE_VENDOR_ORDERING_CART_DATA:
      return {
        ...state,
        vendor_cart_data: action.payload,
      };

    case CLEAR_CART_DATA:
      return {
        ...state,
        vendor_cart_data: [],
      };

    case CLEAR_CART_DATA_USER_DATA:
      return {
        ...state,
        order_id: "",
        substitute_existing_record: {},
        substitute_item_data: [],
        vendor_cart_data: [],
        vendor_order_data: {},
        vendor_filtered_menu: [],
        vendor_suggestions_menu: [],
      };

    case SET_VENDOR_ORDERING_CART_DATA_QUANTITY:
      return {
        ...state,
        vendor_cart_data: action.payload,
      };
    case SET_ORDER_TIP:
      let existingUserData = JSON.parse(
        JSON.stringify(state.vendor_order_data)
      );
      existingUserData.tip = action.payload;
      //existingUserData.
      return {
        ...state,
        vendor_order_data: existingUserData,
      };

    case SET_ORDER_DONATION:
      let existingUserDataDonation = JSON.parse(
        JSON.stringify(state.vendor_order_data)
      );
      existingUserDataDonation.donation = action.payload;
      //existingUserData.
      return {
        ...state,
        vendor_order_data: existingUserDataDonation,
      };
    case SELECTED_SUBSTITUTE_ITEM:
      return {
        ...state,
        substitute_item_data: action.payload,
      };
    case SUBSTITUTE_EXISTING_RECORDS: {
      return {
        ...state,
        substitute_existing_record: action.payload,
      };
    }
    case ORDER_ID:
      return {
        ...state,
        order_id: action.payload,
      };
    case ADD_NEW_SELECTED_ITEM:
      return {
        ...state,
        add_new_selected_item_data: action.payload,
      };
    case ADD_NEW_EXISTING_RECORDS: {
      return {
        ...state,
        add_new_selected_existing_record: action.payload,
      };
    }
    case GET_ALL_DEBIT_CREDIT_MEMO: {
      return {
        ...state,
        all_debit_creit_memo: action.payload,
      };
    }

    case SUGGESTIONS_DATA: {
      return {
        ...state,
        vendor_suggestions_menu: action.payload,
      };
    }

    case VIEW_MEMO_DETAILS: {
      return {
        ...state,
        memo_details: action.payload,
      };
    }

    case APPLY_OFFER_VENDOR: {
      let existingUserData = JSON.parse(
        JSON.stringify(state.vendor_order_data)
      );

      // existingUserData.isOfferApplied = action.payload.isOfferApplied;
      // existingUserData.isPercentage = action.payload.isPercentage;
      // existingUserData.discount = action.payload.discount;
      // existingUserData.coupon_code = action.payload.coupon_code;
      existingUserData = { ...existingUserData, ...action.payload };

      return {
        ...state,
        vendor_order_data: existingUserData,
      };
    }
    case SET_VENDOR_ORDERING_EDIT_DATA: {
      return {
        ...state,
        get_edit_order_data: action.payload,
      };
    }
    case SET_ORDER_TYPE_DETAILS: {
      return {
        ...state,
        orderTypeDetails: action.payload,
      };
    }
    case CLEAR_ORDER_TYPE_DETAILS: {
      return {
        ...state,
        orderTypeDetails: {},
      };
    }
    case SET_CALLING_INFO: {
      return {
        ...state,
        callingInfo: action.payload,
      };
    }
    case SET_TWILIO_TOKEN: {
      return {
        ...state,
        TwilioCallingToken: action.payload,
      };
    }

    case LOG_OUT: {
      return {
        ...state,
        vendor_get_all_takeaway_order: [],
        vendor_get_all_curbside_order: [],
        vendor_get_all_skiptheline_order: [],
        vendor_get_all_dinein_order: [],
        vendor_get_all_buffet_order: [],
        vendor_get_all_catering_order: [],
        vendor_get_all_drivethru_order: [],
        vendor_get_all_delivery_order: [],
        callingInfo: null,
        TwilioCallingToken: null,
      };
    }
    default:
      return state;
  }
}
